import { render, staticRenderFns } from "./DispatchFlowIcon.vue?vue&type=template&id=f2d37a9c&lang=pug"
import script from "./DispatchFlowIcon.vue?vue&type=script&lang=js"
export * from "./DispatchFlowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports